import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import TextArea from '../../../../../components/TextArea/TextArea'
import { TextField } from '../../../../../components/TextField/TextField'
import './AddEditLabTests.scss'
import { ADD, DEPARTURE, OldLabTestsField } from '../../NoteFormsConstants'
import { useDispatch, useSelector } from 'react-redux'
import { getConsultationNotes, getLabTests } from '../../../../../redux/actions/GuestDataActions/ConsultationNotesActions'
import { generateKey, parseJSON } from '../../../../../utils/helpers/universalFunctions'
import {ReactComponent as FileIcon} from '../../../../../assets/images/file.svg'
import { CircularProgress } from '@mui/material'
import { Link } from 'react-router-dom'
import DatePicker from '../../../../../components/DatePicker/DatePicker'
import moment from 'moment'
import MultiSelect from '../../../../../components/MultiSelect/MultiSelect'

export const AddEditLabTests = ({content, setContent, conductedBy, type, formType,  guestId, userProgramId, uploadComponent, setActionOnSubmit})=>{
  return (
    content.data.is_new_form || Array.isArray(content?.data) ?
    <NewForm 
      content={content}
      setContent={setContent}
      conductedBy={conductedBy}
      type={type}
      formType={formType}
      guestId={guestId}
      userProgramId={userProgramId} 
      setActionOnSubmit={setActionOnSubmit}
      uploadComponent={uploadComponent}
    />
    :
    <OldForm 
      content={content}
      setContent={setContent}
      conductedBy={conductedBy}
      type={type}
      formType={formType}
      guestId={guestId}
      userProgramId={userProgramId} 
      uploadComponent={uploadComponent}
    />
  )
}

export const NewForm = ({content, setContent, conductedBy, type, formType,  guestId, userProgramId, uploadComponent, setActionOnSubmit})=>{
  const dispatch = useDispatch()
  const {consultationNotesData, loading, loadingLabTests, labTests, loadingStaticLabTests, staticLabTests} = useSelector(state=> state.consultationNotesReducer)
  
  const staticFields = useMemo(()=>{
    return new Set(staticLabTests?.data?.flatMap(c => c.list).filter(f => f.is_static === 1).map(f => f.test_name))
  }, [staticLabTests])

  const dynamicFields = useMemo(()=>{
    return Object.values(content?.formatted_data|| {})?.filter(item=> !staticFields.has(item.label))
  }, [content])

  const setLabForm=useCallback((data, value)=>{
    setContent(prev=>{
      let updatedData = { ...prev}
      let label = data.test_name || data.label
      let dum = updatedData?.formatted_data?.[label]
      if(!dum){
        updatedData.formatted_data[label] = {
          label: label,
          key: data.key_name || data.key,
          unit: data?.unit || "",
          order_by: data.order_by, 
          value
        }
      }else{
        updatedData.formatted_data[label].value = value
      }
      return updatedData;
    })
  },[])

  const handleMultipleValueFilter = useCallback((selectedOptions)=>{

    setContent(prev=>{
      let updatedData = { ...prev}
      selectedOptions.forEach((option) => {
        let label = option.label
        let dum = updatedData?.formatted_data?.[label]
        if (!dum) {
          updatedData.formatted_data[label] = {...option, value: ""}
        }
      });

      let keysToInclude = selectedOptions.map(option => option.value);

      Object.keys(updatedData.formatted_data).forEach((key)=>{
        if(!staticFields.has(key) && !keysToInclude.includes(key)){
          delete updatedData.formatted_data[key]
        }
      })

      return updatedData;
    })
  },[])


  useEffect(()=>{
      if(guestId && userProgramId && type===DEPARTURE && formType===ADD){
          dispatch(getConsultationNotes({guestId, userProgramId, noteType: "Lab Tests - Arrival"}))
      }
      dispatch(getLabTests())
      dispatch(getLabTests({isStatic: true, categoryGroup: true}))

      setActionOnSubmit(() => {
        return () => {
          let updateData

          setContent(prev=>{
              let newData= {...prev}
              newData.data = Object.values(prev.formatted_data || {})
              updateData = JSON.parse(JSON.stringify(newData))
              return newData
          })
          delete updateData.formatted_data
          return updateData
        };
      });
    },[])


    useEffect(()=>{
        if(type===DEPARTURE){
          let notes_detail = parseJSON(consultationNotesData?.[0]?.list?.[0]?.notes_detail)
          if( formType === ADD){
            setContent(prev=>{
              let newData= {...prev};
              if(notes_detail){
                for (let key in newData.data) {
                  newData.data[key].arrival_reading = notes_detail?.data[key]?.value
                }
              }
              return newData;
            })
          }
        } else if(staticLabTests?.data?.length>0){
          setContent(prev=>{
            let newData= {...prev};
            newData.date = newData.date || moment().format("YYYY-MM-DD")
            newData.formatted_data={}
            newData?.data?.map((item)=>{
              newData.formatted_data[item.label]=item
            })
            return newData;
          })
        }
    },[consultationNotesData, staticLabTests])

    return (
      <div>
        {
          loading || loadingStaticLabTests ?
          <div className="loader mx-auto">
            <CircularProgress sx={{'color': '#74613C'}} size={20}/>
          </div>
          :
          <>
            <div className='text-danger border border-danger rounded py-2 fw-semi-bold text-center my-2'>
              THIS ENTIRE FORM WILL BE AUTOMATICALLY VISIBLE TO GUEST ON SUBMISSION
            </div>
            <div className="d-flex py-2 mb-3 rounded justify-content-between">
              <div className="d-flex align-items-center">
                <div className="title text-secondary me-3">Conducted By: </div>
                  {conductedBy || '-'}
              </div>
              <div className="d-flex align-items-center">
                <div className="title text-secondary me-3">Date</div>
                <DatePicker
                  value={content.date ? new Date(content.date) : ''}
                  onChange={date=>setContent(prev=>({...prev, date: moment(date).format('YYYY-MM-DD')}) )}
                  width={'300px'}
                />
              </div>
            </div>
            <div className='border-top d-flex align-items-center border-bottom py-3 mb-4'>
                <div className='text-muted fw-semi-bold me-3'>Select Tests</div>
                <div style={{width: '400px'}}>
                  <MultiSelect
                    loading={loadingLabTests}
                    options={[
                      ...(labTests ? labTests?.data?.map((item)=>({
                          label: item.test_name,
                          key: item.key_name,
                          value:  item.test_name,
                          unit: item?.unit || "",
                          order_by: item.order_by
                      })) : [])
                      ]}
                      width={'100%'}
                      defaultValue={dynamicFields ? dynamicFields?.map((item)=>({
                        label: item.label,
                        value: item.label
                      })) : []}
                      onClickOk={(values)=>{handleMultipleValueFilter(values)}}
                      hasSelectAllOption={false}
                  />
                </div>
              </div>
            <div className="d-flex border rounded justify-content-between w-100">
              <div className="lab-tests-form  ">
                {
                  type===DEPARTURE && <div className="fw-semi-bold mb-4 text-uppercase">Departure Data</div>
                }
                {
                    staticLabTests?.data?.map((cat, ind)=>{
                      return (
                        <>
                          <div className='align-top p-3 w-100 py-3 fw-semi-bold border-bottom position-sticky text-uppercase start-0 border-top mb-4' style={{ backgroundColor: '#F5F3EE' }}>{cat.category_title || '-'}</div>
                          {cat?.list?.map((item, index)=>{
                            return(
                              <div className="data-row mb-4 px-3" style={{width:"40%"}} key={index}>
                                <div className="title">{item.test_name}</div>
                                <div className='data-input'>
                                  <div className='input-container'>
                                    <TextField 
                                        type={item.type}
                                        placeholder='Enter value' 
                                        value={content?.formatted_data?.[item.test_name]?.value || ''} 
                                        onChange={e=>setLabForm(item,  e.target.value)}
                                        unit={item?.unit || ""}
                                    />
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                        </>
                      )
                    })
                }
                {
                  dynamicFields?.length>0 &&
                  <div className='align-top p-3 w-100 py-3 fw-semi-bold border-bottom position-sticky text-uppercase start-0 border-top mb-4' style={{ backgroundColor: '#F5F3EE' }}>OTHER TESTS</div>

                }
                {
                    dynamicFields?.map((item, index)=>{
                      return(
                        <div className="data-row mb-4 px-3 "  style={{width:"40%"}}  key={index}>
                          <div className="title">{item.label}</div>
                          <div className='data-input'>
                            <div className='input-container'>
                              <TextField 
                                  type={item.type}
                                  placeholder='Enter value' 
                                  value={content?.formatted_data?.[item.label]?.value || ''} 
                                  onChange={e=>setLabForm(item,  e.target.value)}
                                  unit={item.unit}
                              />
                            </div>
                          </div>
                        </div>
                    )
                    })
                }
                <div className='px-3  style={{width:"40%"}}'>
                {uploadComponent}
                </div>
              </div>
              
            </div>
          </>
        }
      </div>
    )
}

export const OldForm = ({content, setContent, conductedBy, type, formType,  guestId, userProgramId, uploadComponent})=>{
  const dispatch = useDispatch()
  const[arrivalDataFiles, setArrivalDataFiles] = useState({})
  const {consultationNotesData, loading} = useSelector(state=> state.consultationNotesReducer)
  const setLabForm = (key, value)=>{
  }

    useEffect(()=>{
      if(guestId && userProgramId && type===DEPARTURE && formType===ADD){
          dispatch(getConsultationNotes({guestId, userProgramId, noteType: "Lab Tests - Arrival"}))
      }
    },[])

    useEffect(()=>{
        if(type===DEPARTURE){
          let notes_detail = parseJSON(consultationNotesData?.[0]?.list?.[0]?.notes_detail)
          if( formType === ADD){
            setContent(prev=>{
              let newData= {...prev};
              newData.date = moment().format("YYYY-MM-DD")

              if(notes_detail){
                for (let key in newData.data) {
                  newData.data[key].arrival_reading = notes_detail?.data[key]?.value
                }
              }
              return newData;
            })
            if(notes_detail)
              setArrivalDataFiles(p=>{
                return {
                  notes_doc : consultationNotesData?.[0]?.list?.[0]?.notes_doc,
                  notes_url : consultationNotesData?.[0]?.list?.[0]?.notes_url
                }
              })
          }
        }
    },[consultationNotesData])

    return (
      <div>
        {
          loading ?
          <div className="loader mx-auto">
            <CircularProgress sx={{'color': '#74613C'}} size={20}/>
          </div>
          :
          <>
            <div className="d-flex py-2 mb-3 rounded justify-content-between">
              <div className="d-flex align-items-center">
                <div className="title text-secondary me-3">Conducted By: </div>
                {/* <TextField
                    width={'300px'}
                    type={'text'}
                    placeholder='Enter name' 
                    value={content?.conducted_by || ''} 
                    onChange={e=>setContent( {...content, 'conducted_by' : e.target.value})}
                  /> */}
                  {conductedBy || '-'}
              </div>
              <div className="d-flex align-items-center">
                <div className="title text-secondary me-3">Date</div>
                <DatePicker
                  value={content.date ? new Date(content.date) : ''}
                  onChange={date=>setContent( {...content, 'date' : moment(date).format('YYYY-MM-DD')})}
                  width={'300px'}
                />
              </div>
            </div>
            <div className="d-flex  p-3 border rounded justify-content-between w-100">
            {
              type===DEPARTURE &&
              <div className='lab-tests-old-form'>
                  <div className="fw-semi-bold mb-4 text-uppercase">Arrival Data</div>
                  <div>
                  <div className=' position-relative'>
                      {
                      OldLabTestsField?.map((item, index)=>(
                          <div className="data-row mb-4" key={index}>
                          <div className="title text-secondary">{item.label}</div>
                          <div className='data-input'>
                          {content?.data?.[item.key]?.arrival_reading || '-'} 
                          </div>
                          </div>
                      ))
                      }
                  </div>
                 </div>
              </div>
              }
              <div className="lab-tests-form  ">
                {
                  type===DEPARTURE && <div className="fw-semi-bold mb-4 text-uppercase">Departure Data</div>
                }
                {
                    OldLabTestsField?.map((item, index)=>(
                    <div className="data-row mb-4" key={index}>
                        <div className="title">{item.label}</div>
                        <div className='data-input'>
                            {
                            item.type!=='textarea'?
                            <div className='input-container'>
                            <TextField 
                                type={item.type}
                                placeholder='Enter value' 
                                value={content?.data?.[item.key]?.value || ''} 
                                onChange={e=>setLabForm(item.key, e.target.value)}
                                unit={""}
                            />
                            </div>
                            :
                            <TextArea
                              placeholder={"Enter value"}
                              onChange={value =>setLabForm(item.key, value)}
                              value={content?.data?.[item.key] || ''}/>
                            }
                        </div>
                    </div>
                    ))
                }
                {uploadComponent}
                </div>
            </div>
          </>
        }
      </div>
    )
}